import type { ReactNode } from "react";
import { useCRT } from "../../hooks";
import { Container } from "../uikit";

export interface ScreenFooterProps {
  children?: ReactNode;
  /** Distance from bottom of screen (default: 40) */
  bottomOffset?: number;
}

/**
 * CRTScreen.Footer - Container for footer content positioned at the bottom of the screen
 *
 * Place as a sibling to CRTScreen.Background and CRTScreen.Content inside CRTScreen.Root.
 * Footer will be positioned at the bottom of the screen.
 *
 * @example
 * ```tsx
 * <CRTScreen.Root>
 *   <CRTScreen.Background>...</CRTScreen.Background>
 *   <CRTScreen.Content>...</CRTScreen.Content>
 *   <CRTScreen.Footer>
 *     <MyFooterContent />
 *   </CRTScreen.Footer>
 * </CRTScreen.Root>
 * ```
 */
export function ScreenFooter({
  children,
  bottomOffset = 40,
}: ScreenFooterProps) {
  const { width, height } = useCRT();

  return (
    <Container
      positionType="absolute"
      positionLeft={0}
      positionTop={height - bottomOffset}
      width={width}
      alignItems="center"
      justifyContent="center"
      flexDirection="row"
    >
      {children}
    </Container>
  );
}
